@if (addEditModalOpen) {
  <app-add-transaction-type-modal
    [editMode]="isEditMode"
    [editData]="editRow"
    (closeModal)="closeAddEditModal()"
  ></app-add-transaction-type-modal>
}

<kehe-phoenix-modal
  [show]="deactivateModalOpen"
  size="md"
  modalTitle="Deactivate Transaction Type"
  (closeEvent)="closeDeactivateModal()"
>
  <div body>
    <p>Are you sure you would like to deactivate the selected template?</p>

    <p class="mt-3">
      <strong>Transaction Type:</strong>
      {{ selectedTransactionTypeLabel }}
    </p>
  </div>
  <div footer class="d-flex justify-content-end">
    <kehe-phoenix-button
      data-automation-id="transaction-type-deactivate-cancel-button"
      (click)="closeDeactivateModal()"
      classAttr="btn-link btn-medium"
    >
      Cancel
    </kehe-phoenix-button>

    <kehe-phoenix-button
      classAttr="btn-secondary btn-delete btn-modal btn-medium  ms-2"
      data-automation-id="transaction-type-deactivate-confirm-button"
      (click)="confirmDeactivate()"
    >
      Deactivate
    </kehe-phoenix-button>
  </div>
</kehe-phoenix-modal>

<kehe-phoenix-modal
  [show]="reactivateModalOpen"
  size="md"
  modalTitle="Reactivate Transaction Type"
  (closeEvent)="closeReactivateModal()"
>
  <div body>
    @if (showReactivateWarning) {
      <kehe-phoenix-alert
        [show]="true"
        type="warning"
        stick="true"
        [hideCloseIcon]="true"
        [messageAsHtml]="modalText"
      ></kehe-phoenix-alert>
    }
    <p>Are you sure you would like to reactivate the selected template?</p>

    <p class="mt-3">
      <strong>Transaction Type:</strong>
      {{ selectedTransactionTypeLabel }}
    </p>
  </div>
  <div footer class="d-flex justify-content-end">
    <kehe-phoenix-button
      data-automation-id="transaction-type-reactivate-cancel-button"
      (click)="closeReactivateModal()"
      classAttr="btn-link btn-medium"
    >
      Cancel
    </kehe-phoenix-button>

    <kehe-phoenix-button
      classAttr="btn-secondary btn-delete btn-modal btn-medium  ms-2"
      data-automation-id="transaction-type-reactivate-confirm-button"
      (click)="confirmReactivate()"
    >
      Reactivate
    </kehe-phoenix-button>
  </div>
</kehe-phoenix-modal>

@if (vm$ | async; as vm) {
  <div class="row grid-filters mb-2 justify-content-end" [formGroup]="form">
    <div class="col-sm-4 d-flex">
      <div class="w-100">
        <kehe-phoenix-search
          name="txtSearchProductList"
          ngDefaultControl
          placeholder="Search"
          formControlName="search"
        ></kehe-phoenix-search>
      </div>
    </div>
  </div>
  <div>
    <div class="kehe-grid no-scroll p-0 w-100">
      <kendo-grid
        [pageable]="false"
        [sort]="vm.selectedSort"
        [data]="vm.gridData"
        [sortable]="{ allowUnsort: false, mode: 'single' }"
        (sortChange)="sortChange($event)"
      >
        <!-- Menu -->
        <kendo-grid-column
          [width]="50"
          [sortable]="false"
          [class]="'phx-menu-col'"
          [headerClass]="'phx-menu-col'"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="d-flex justify-content-center">
              <kehe-phoenix-menu-button
                btnClass="btn-link"
                [menuOptions]="
                  dataItem?.menuOptions?.length
                    ? dataItem.menuOptions
                    : defaultEllipsesMenuOptions
                "
                (optionSelected)="onEllipsisOptionSelected($event, dataItem)"
              ></kehe-phoenix-menu-button>
            </div>
          </ng-template>
        </kendo-grid-column>

        <!-- Transaction Type -->
        <kendo-grid-column
          [width]="220"
          [field]="'transactionType'"
          [title]="'Transaction Type'"
          [locked]="false"
          [sortable]="true"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <span> {{ dataItem.codeValue || '--' }}</span>
          </ng-template>
        </kendo-grid-column>
        <!-- Template File -->
        <kendo-grid-column
          [width]="220"
          [field]="'templateFile'"
          [title]="'Template File'"
          [locked]="false"
          [sortable]="true"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <a (click)="onTemplateDownload(dataItem)">
              <span>{{ dataItem.s3KeyTemplate || '--' }}</span></a
            >
          </ng-template>
        </kendo-grid-column>
        <!-- Cost Center -->
        <kendo-grid-column
          [width]="100"
          [field]="'costCenter'"
          [title]="'Cost Center'"
          [locked]="false"
          [sortable]="true"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{ dataItem.costCenter || '--' }}</span>
          </ng-template>
        </kendo-grid-column>
        <!-- Spend Category -->
        <kendo-grid-column
          [width]="150"
          [field]="'spendCategory'"
          [title]="'Spend Category'"
          [locked]="false"
          [sortable]="true"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{ dataItem.spendCategoryId || '--' }}</span>
          </ng-template>
        </kendo-grid-column>
        <!-- Last Edited By -->
        <kendo-grid-column
          [width]="150"
          [field]="'lastEditedBy'"
          [title]="'Last Edited By'"
          [locked]="false"
          [sortable]="true"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="d-flex flex-column">
              <span>{{ dataItem.lastUpdatedBy || dataItem.createdBy }}</span>
              <span>{{
                dataItem.lastUpdatedUtc || dataItem.createdUtc
                  | date: 'MM/dd/yyyy'
              }}</span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <!-- Status -->
        <kendo-grid-column
          [field]="'__status__'"
          [title]="'Status'"
          [width]="100"
          [locked]="false"
          [sortable]="false"
          [class]="'phx-status-col'"
          [headerClass]="'phx-status-col'"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <kehe-phoenix-tag
              [tag]="
                dataItem.isActive
                  ? {
                      text: 'Active',
                      bgColor: '#D5E48F',
                      borderColor: '#D5E48F',
                    }
                  : { text: 'Inactive' }
              "
              classAttr="large"
            >
            </kehe-phoenix-tag>
          </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
          @if (!vm.isLoading) {
            @if (!vm.isLoading) {
              <kehe-phoenix-empty-state></kehe-phoenix-empty-state>
            }
          }
          @if (vm.isLoading) {
            @if (vm.isLoading) {
              <kehe-phoenix-grid-loader></kehe-phoenix-grid-loader>
            }
          }
        </ng-template>
      </kendo-grid>
      @if (vm.gridData && vm.gridData.length > 0) {
        <kendo-datapager
          [pageSize]="vm.gridConfig.pageCount"
          [skip]="vm.gridConfig.pageIndex * vm.gridConfig.pageCount"
          [total]="vm.totalRecords"
          [buttonCount]="4"
          [pageSizeValues]="[25, 50, 100, 250]"
          (pageChange)="onPageChange($event)"
        >
        </kendo-datapager>
      }
    </div>
  </div>
}
